
export function evaluation(htmlFc, restriction) { 
    
    if (restriction.val === 'ok') {
        return;
    }
   
   const inputToRestrict = restriction.restrictedFields;

    for (let x = 0; x < htmlFc.form.length ; x++) {   
        for (let y = 0; y < inputToRestrict.length ; y++) {   
            if(htmlFc.form[x].name === inputToRestrict[y].id) { 

                    htmlFc.form[x].html.classList.add('textfield-restriction')
               
            }
        }
    }
    ///MT
    const clientSaleVsItem        = document.getElementById('clientSale_form_clientSale_vs_item')

    clientSaleVsItem.classList.add('multitable-restriction')

}/**/


